import { FC } from 'react'
import { PathRouteProps } from 'react-router-dom'
import type { SvgIconProps } from '@mui/material/SvgIcon'

enum Pages {
  ApplicationReview = 'AmlReview',
  BusinessDocuments = 'BusinessDocuments',
  BankDetail = 'BankDetail',
  ChooseDevice = 'ChooseDevice',
  StoreVerification = 'StoreVerification',
  NotFound = 'NotFound',
  Login = 'Login',
  ThirdPartyLogin = 'ThirdPartyLogin',
  PanDetail = 'PanDetail',
  UenDetails = 'UenDetail',
  TinDetails = 'TinDetail',
  kycVerification = 'KycVerification',
  Home = 'Home',
  CreateLead = 'CreateLead',
  CreateOpportunity = 'CreateOpportunity',
  BusinessDetails = 'BusinessDetails',
  BusinessDetail = 'BusinessDetail',
  CapturePhoto = 'CapturePhoto',
  KycDetails = 'KycDetails',
  Products = 'Products',
  LeadsListing = 'LeadsListing',
  BankAccount = 'BankAccount',
  VasListing = 'VasListing',
  ReviewDetails = 'ReviewDetails',
  ReviewDetail = 'ReviewDetail',
  PricingPlan = 'PricingPlan',
  ProductReview = 'ProductReview',
  POPayment = 'POPayment',
  NachMandate = 'NachMandate',
  NachMandateStatus = 'NachMandateStatus',
  PurchaseOrder = 'PurchaseOrder',
  NachLotusStatus = 'NachLotusStatus',
  Deployment = 'Deployment',
  PricingLWC = 'PricingLWC',
  DeploymentMulti = 'DeploymentMulti',
  OtherBusinessDoc = 'OtherBusinessDoc',
  PartnershipKyc = 'PartnershipKyc',
  FAQScreen = 'FAQScreen',
  YoutubePlayer = 'YoutubePlayer',
  AllFAQSection = 'AllFAQSection',
  MultiStores = 'MultiStores',
  LiveDevices = 'LiveDevices',
  LiveDeviceDetails = 'LiveDeviceDetails',
  CompleteDeploment = 'CompleteDeploment',
  LinkPaymentDevices = 'LinkPaymentDevices',
  MapDevices = 'MapDevices',
  TestTransactions = 'TestTransactions',
  ClosureRemarks = 'ClosureRemarks',
  NachDocumentUpload = 'NachDocumentUpload',
  InventoryManagement = 'InventoryManagement',
  kycMerchantDetails = 'kycMerchantDetails',
  CaptureSignature = 'CaptureSignature',

  RevisitFeedback = 'revisit/feedback',
  RevisitMerchantDetails = 'revisit/merchant-details',
  RevisitComplete = 'revisit/complete',
  RevisitConfirmLocation = 'revisit/confirm-location',
  RevisitConfirmOTP = 'revisit/confirm-otp',
  RevisitShopForm = 'revisit/shopform',
  RevisitPhotos = 'revisit/photos',
  RevisitMapQR = 'revisit/map-qr',
  RevisitLoading = 'revisit/loading',
  PreviewOrder = 'PreviewOrder',
  MdrProduct = 'MdrProduct',
  ProductDetail = 'ProductDetail',
  ProductDetailVas = 'ProductDetailVas',
  BusinessInfo = 'BusinessInfo',
  DeploymentRequestsListing = 'DeploymentRequestsListing',
  UploadContactListDoc = 'UploadContactListDoc',
  SSMVerification = 'SSMVerification',
}

type PathRouteCustomProps = {
  title?: string
  component: FC
  icon?: FC<SvgIconProps>
}

type Routes = Record<Pages, PathRouteProps & PathRouteCustomProps>

export type { Routes }

export { Pages }
